import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { toastMessage } from "../../../shared/components/common/toast";
import { setUser } from "../../../shared/redux/reducers/userSlice";
import { AcceptOffer } from "../../../shared/services/bookService";
import { Reject } from "../../../shared/services/offerService";
import DigiBook from "../../../abis/DigiBook.json";
import { getWeb3 } from "../../../shared/util/getWeb3";
import axios from "axios";
import OfferCard from "../offersCard";

import "./style.css";

function OfferCard2({ item, reload }) {
  const user = useSelector((state) => state.root.user);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [loader2, setLoader2] = useState(false);
  let ammountToBePaid =
    parseInt(item?.offeringBook?.library?.price) -
    parseInt(item?.offeredBook?.library?.price);
  const handleAccept = async () => {
    let web3 = await getWeb3(null);
    const accounts = await web3?.eth.getAccounts();
    const networkId = await web3?.eth.net.getId();
    const networkData = DigiBook.networks[networkId];
    setLoader2(true);
    let obj = {
      book1: item?.offeredBook?._id,
      book2: item?.offeringBook?._id,
      offer: item?._id,
    };
    let ammountToBePaid = 0;

    await axios
      .get(
        "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=bitcoin%2Cethereum&order=market_cap_desc&per_page=100&page=1&sparkline=false"
      )
      .then(async (res) => {
        let price = 0;
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].name === "Ethereum") {
            price = res.data[i].current_price;
          }
        }
        ammountToBePaid =
          (parseInt(item?.offeringBook?.library?.price) -
            parseInt(item?.offeredBook?.library?.price)) /
          price;
        if (networkData) {
          const abi = DigiBook.abi;
          const address = networkData.address;
          const contract = new web3.eth.Contract(abi, address);
          try {
            console.log("Values", item);
            const x = await contract.methods
              .swap(
                accounts[0],
                item?.offeringUser.walletaddress,
                item?.offeredToken,
                item?.offeringToken
              )
              .send({
                from: accounts[0],
                value: web3.utils.toWei(ammountToBePaid.toString(), "ether"),
              });
            await AcceptOffer(user?.token, obj)
              .then((res) => {
                if (res.statusText === "OK") {
                  setLoader2(false);
                  let resp = {
                    ...user,
                  };
                  dispatch(setUser(resp));
                  toastMessage("Offer Accepted", "success");
                  reload();
                } else {
                  setLoader2(false);
                  toastMessage(res.data, "error");
                }
              })
              .catch((error) => {
                console.log(error.message);
                setLoader2(false);
              });
          } catch (err) {
            console.log(err);
            setLoader2(false);
            toastMessage(err.message, "error");
          }
        } else {
          toastMessage("Smart Contract not deployed!", "error");
        }
      })
      .catch((error) => console.log(error));
  };
  const handleReject = async () => {
    setLoader(true);
    await Reject(user?.token, item?._id)
      .then((res) => {
        if (res.statusText === "OK") {
          setLoader(false);
          toastMessage("Offer Rejected", "success");
          reload();
        } else {
          setLoader(false);
          toastMessage(res.data, "error");
        }
      })
      .catch((error) => {
        toastMessage(error.message, "error");
        setLoader(false);
      });
  };
  return (
    <div
      data-aos="fade-up"
      data-aos-duration="500"
      className="offer-card-top-container mb-5 mt-5 rounded"
    >
      <h4 className="px-4 py-4 color-green">Approved by Other Party</h4>
      <div className="offer-card-container px-4">
        <OfferCard item={item} reload={reload} />
      </div>

      <div className="d-flex flex-row justify-content-around pb-2 mt-4">
        <button className="custom-site-red-btn" onClick={handleReject}>
          {loader ? <Spinner animation="grow" size="sm" /> : "Reject"}
        </button>
        <button className="custom-site-green-btn" onClick={handleAccept}>
          {loader2 ? (
            <Spinner animation="grow" size="sm" />
          ) : (
            `Pay $${ammountToBePaid}`
          )}
        </button>
      </div>
    </div>
  );
}

export default OfferCard2;
